import { render, staticRenderFns } from "./RequestAffectationDialog.vue?vue&type=template&id=1527443f&scoped=true"
import script from "./RequestAffectationDialog.vue?vue&type=script&lang=js"
export * from "./RequestAffectationDialog.vue?vue&type=script&lang=js"
import style0 from "./RequestAffectationDialog.vue?vue&type=style&index=0&id=1527443f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527443f",
  null
  
)

export default component.exports